interface Props {
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary;
}

function HeroTourOfferDetails(_props: Props) {
  return null
}

export default HeroTourOfferDetails
